import { BuildingOwnerPerson, BuildingOwners } from '@app/core/stingray-api/models';
import { ApplicantView } from './applicant-view';

export class NewApplicantView extends ApplicantView {

  isRetrievingBuildingOwners = false;
  buildingOwners: BuildingOwners;

  selectedBuildingOwnerPersons: BuildingOwnerPerson[] = [];

  isSelectedBuildingOwnerPerson(person: BuildingOwnerPerson): boolean {
    return this.selectedBuildingOwnerPersons.indexOf(person) > -1;
  }

  selectBuildingOwnerPerson(person: BuildingOwnerPerson): void {
    if (!this.isSelectedBuildingOwnerPerson(person)) {
      this.selectedBuildingOwnerPersons.push(person);
    } else {
      this.selectedBuildingOwnerPersons.splice(this.selectedBuildingOwnerPersons.indexOf(person));
    }
  }

  isValid(): boolean {
    if (this.form.get('customerType').value === 'Company') {
      return true;
    } else {
      const ownsDutchRealEstateControl = this.form.get('ownsDutchRealEstate');
      if (ownsDutchRealEstateControl.valid && !!ownsDutchRealEstateControl.value) {
        return this.selectedBuildingOwnerPersons.length > 0;
      } else {
        return this.form.valid;
      }
    }
  }
}
